<template>
  <div class="chart-wrapper-page">
    <!-- Chart Card -->
    <div class="chart-card">
      <div class="chart-header">
        <h3 class="chart-title">Devices Sold by Agents</h3>
        <div class="year-filters">
          <button
            :class="['year-btn', { active: selectedYear === getLastYearRange }]"
            @click="fetchData(getLastYearRange)"
          >
            {{ this.getLastYearRange[0].substring(0, 4) }}
          </button>
          <button
            :class="['year-btn', { active: selectedYear === getThisYearRange }]"
            @click="fetchData(getThisYearRange)"
          >
            {{ this.getThisYearRange[0].substring(0, 4) }}
          </button>
        </div>
      </div>

      <div class="chart-container">
        <div v-if="isLoading" class="loading-state">
          <icon name="spinner" spin class="spinner"></icon>
          <p>Loading chart data...</p>
        </div>
        <stacked-bar-chart
          v-else
          :chart-data="chartData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";

import "vue-awesome/icons/spinner";

export default {
  components: {
    Icon: () => import("vue-awesome/components/Icon.vue"),
    "stacked-bar-chart": () =>
      import("@/components/common/charts/StackedBarChart.vue"),
  },
  data() {
    return {
      chartData: { },
      isLoading: false,
      selectedYear: null
    }
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    fetchData(range) {
      this.selectedYear = range;
      const data = {
        query: `
          query  {
            DevicesEventsDetailsAgentsYearStats(
              from: "${range[0]}",
              to: "${range[1]}"
            )
          }
        `
      };
      this.isLoading = true;
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res) {
          this.chartData = JSON.parse(res.DevicesEventsDetailsAgentsYearStats);
        }
      }).finally(() => {
        this.isLoading = false;
      })
    }
  },
  computed: {
    ...mapGetters([
      "getThisYearRange",
      "getLastYearRange",
      "getUserSystem"
    ])
  },
  watch: {
    getUserSystem: function() {
      this.fetchData(this.getThisYearRange);
    }
  },
  mounted() {
    this.selectedYear = this.getThisYearRange;
    this.fetchData(this.getThisYearRange);
  }
};
</script>

<style scoped>
.chart-wrapper-page {
  padding: 0;
  background-color: transparent;
}

.chart-card {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e2e8f0;
  flex-wrap: wrap;
  gap: 16px;
}

.chart-title {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
}

.year-filters {
  display: flex;
  gap: 8px;
  background: #f7fafc;
  padding: 4px;
  border-radius: 8px;
}

.year-btn {
  padding: 8px 20px;
  border: none;
  background: transparent;
  color: #4a5568;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 80px;
}

.year-btn:hover {
  background-color: #edf2f7;
}

.year-btn.active {
  background-color: #5469d4;
  color: white;
}

.chart-container {
  height: 400px;
  position: relative;
}

.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #718096;
}

.loading-state .spinner {
  font-size: 32px;
  margin-bottom: 12px;
  color: #5469d4;
}

.loading-state p {
  margin: 0;
  font-size: 14px;
}

@media (max-width: 768px) {
  .chart-wrapper-page {
    padding: 0;
  }

  .chart-card {
    padding: 16px;
  }

  .chart-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .year-filters {
    width: 100%;
  }

  .year-btn {
    flex: 1;
  }

  .chart-container {
    height: 300px;
  }
}
</style>
